module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "max-height": "250px",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, _vm._l((_vm.fileElements), function(file) {
    return _c('a', {
      key: file.key,
      staticClass: "transparent",
      attrs: {
        "target": "_blank",
        "href": file.value
      }
    }, [_c('div', {
      key: file.key,
      staticClass: "workflow-file hover-darken clickable",
      on: {
        "click": function($event) {
          return _vm.fileClicked(file)
        }
      }
    }, [(!file.loading) ? _c('v-icon', {
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      },
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("attachment")]) : _vm._e(), _vm._v(" "), (file.loading) ? _c('v-progress-circular', {
      staticClass: "grey--text",
      staticStyle: {
        "float": "left",
        "margin-right": "5px"
      },
      attrs: {
        "size": 20,
        "width": 2,
        "indeterminate": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "nudge-width": 200
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            staticStyle: {
              "margin-right": "11px"
            },
            attrs: {
              "color": "grey"
            }
          }, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('menu', 'delete', file)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('menu', 'email', file)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Email")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "truncate",
      staticStyle: {
        "padding-top": "2px"
      }
    }, [_vm._v(_vm._s(file.title))])], 1)])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6a16d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TransactionFiles.vue
// module id = 2618
// module chunks = 1